import { useEffect, useState } from "react";

const Combo = ({ comboCount }: { comboCount: number }) => {
  const [showComboAnimation, setShowComboAnimation] = useState(false);
  const [prevComboCount, setPrevComboCount] = useState(comboCount);

  // Detect combo count changes and trigger bounce animation
  useEffect(() => {
    if (comboCount > 2 && comboCount !== prevComboCount) {
      setShowComboAnimation(true);
      setTimeout(() => setShowComboAnimation(false), 4000);
    }
    setPrevComboCount(comboCount);
  }, [comboCount, prevComboCount]);

  if (comboCount <= 2 || !showComboAnimation) { 
    return null;
  }

  // Calculate shake intensity based on combo count (5-10)
  const getShakeIntensity = () => {
    if (comboCount < 5) return 0;
    if (comboCount >= 10) return 1;
    return (comboCount - 5) / 5; // Linear interpolation from 0 to 1
  };

  const shakeIntensity = getShakeIntensity();
  const shakeAmplitude = shakeIntensity * 3; // Max 3px shake

  return (
    <>
      <div 
        className='absolute top-[100px] left-0 right-0 flex justify-center z-50 overflow-hidden'
        style={{
          animation: 'slideDownAndUp 4s ease-out forwards',
        }}
      >
        <div className='bg-white rounded-b-2xl px-8 py-3'>
          <div 
            className='text-xl display-text-bold' 
            style={{ 
              color: comboCount >= 5 ? "#F19B38" : "#42C52D",
              animation: comboCount >= 5 ? `shake ${0.5 - shakeIntensity * 0.3}s ease-in-out infinite` : 'none',
              animationDelay: '0.5s', // Start shaking after slide down
            }}
          >
            {comboCount} IN A ROW 🔥
          </div>
        </div>
      </div>
      <style jsx>{`
        @keyframes shake {
          0%, 100% {
            transform: translateX(0);
          }
          10% {
            transform: translateX(-${shakeAmplitude}px) rotate(-${shakeIntensity}deg);
          }
          20% {
            transform: translateX(${shakeAmplitude}px) rotate(${shakeIntensity}deg);
          }
          30% {
            transform: translateX(-${shakeAmplitude * 0.8}px) rotate(-${shakeIntensity * 0.8}deg);
          }
          40% {
            transform: translateX(${shakeAmplitude * 0.8}px) rotate(${shakeIntensity * 0.8}deg);
          }
          50% {
            transform: translateX(-${shakeAmplitude * 0.6}px) rotate(-${shakeIntensity * 0.6}deg);
          }
          60% {
            transform: translateX(${shakeAmplitude * 0.6}px) rotate(${shakeIntensity * 0.6}deg);
          }
          70% {
            transform: translateX(-${shakeAmplitude * 0.4}px) rotate(-${shakeIntensity * 0.4}deg);
          }
          80% {
            transform: translateX(${shakeAmplitude * 0.4}px) rotate(${shakeIntensity * 0.4}deg);
          }
          90% {
            transform: translateX(-${shakeAmplitude * 0.2}px) rotate(-${shakeIntensity * 0.2}deg);
          }
        }
        
        @keyframes slideDownAndUp {
          0% {
            transform: translateY(-100%);
            opacity: 0;
          }
          10% {
            transform: translateY(0);
            opacity: 1;
          }
          90% {
            transform: translateY(0);
            opacity: 1;
          }
          100% {
            transform: translateY(-100%);
            opacity: 0;
          }
        }
      `}</style>
    </>
  )
}

export default Combo;